var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dateString)?_c('v-chip',{attrs:{"color":"orange","text":"","outlined":""}},[_vm._v(" "+_vm._s(_vm.dateString)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }